import "./style.css";

const ITEMS_AMOUNT = 3;

export default class TwitterFeed {
  static selector = ".twitter-feed";

  constructor(block) {
    this.block = block;

    this.rtl = document.documentElement.getAttribute("dir") === "rtl" && true;

    this.carousel = this.block.querySelector(
      ".twitter-feed__carousel__wrapper"
    );

    this.list = this.carousel.querySelector(".twitter-feed__list");
    this.items = this.list.querySelectorAll(".twitter-feed__list__item");

    this.next = this.block.querySelector(
      ".twitter-feed__header__arrows__arrow__right"
    );
    this.prev = this.block.querySelector(
      ".twitter-feed__header__arrows__arrow__left"
    );

    this.numberOfSlides = Math.ceil(
      this.items.length / ITEMS_AMOUNT
    );

    this.carouselWidth = this.carousel.offsetWidth;
    this.slide = 0;
    this.innerWidth = window.innerWidth;

    this.initialX = null;
    this.initialY = null;

    this.isMobile = this.innerWidth <= 768;

    this.setEventListeners();

    if (!this.isMobile) {
      this.hideArrowButtons();
    }

    window.addEventListener("resize", this.setOffsetWidth);

    // this.carousel.addEventListener("touchstart", this.handleTouchStart);
    // this.carousel.addEventListener("touchmove", this.handleTouchMove);
  }

  setOffsetWidth = () => {
    this.carouselWidth = this.carousel.offsetWidth;
    this.innerWidth = window.innerWidth;
    this.setSlide();
  };

  hideArrowButtons = () => {
    if (
      Array.from(this.items).length < ITEMS_AMOUNT
    ) {
      this.prev.classList.remove("show");
      this.next.classList.remove("show");
    } else {
      this.prev.classList.add("show");
      this.next.classList.add("show");
    }
  };

  setEventListeners = () => {
    this.next.addEventListener("click", this.setNext);
    this.prev.addEventListener("click", this.setPrev);
  };

  handleTouchStart = (e) => {
    this.initialX = e.touches[0].clientX;
    this.initialY = e.touches[0].clientY;
  };

  handleTouchMove = (e) => {
    if (this.initialX === null) {
      return;
    }

    if (this.initialY === null) {
      return;
    }

    let currentX = e.touches[0].clientX;
    let currentY = e.touches[0].clientY;

    let diffX = this.rtl
      ? -(this.initialX - currentX)
      : this.initialX - currentX;
    let diffY = this.rtl
      ? -(this.initialY - currentY)
      : this.initialY - currentY;

    if (Math.abs(diffX) > Math.abs(diffY)) {
      if (diffX > 0 && this.slide < this.items.length - 1) {
        this.setNext(e);
      } else if (diffX > 0 && this.slide == this.items.length - 1) {
      } else {
        this.setPrev();
      }
    }
    this.initialX = null;
    this.initialY = null;
  };

  setDesktopSlide = () => {
    this.itemWidth = this.carouselWidth + 50;
    this.list.style.transform = this.rtl
      ? `translateX(${this.slide * this.itemWidth}px)`
      : `translateX(-${this.slide * this.itemWidth}px)`;
  };

  setMobileSlide = () => {
    const itemWidth = this.items[this.slide].getBoundingClientRect().width + 20;
    this.list.style.transform = this.rtl
      ? `translateX(${this.slide * itemWidth}px)`
      : `translateX(-${this.slide * itemWidth}px)`;
  };

  setSlide = () => {
    this.isMobile ? this.setMobileSlide() : this.setDesktopSlide();
  };

  setMobileArrowDisabled = () => {
    if (this.slide === this.items.length - 1) {
      this.next.classList.add("disabled");
    } else {
      this.next.classList.remove("disabled");
    }
  };

  setNext = (e) => {
    this.slide += 1;

    this.setSlide();

    this.prev.classList.remove("disabled");
    if (!this.isMobile) {
      if (
        // this.list.offsetWidth - this.slide * this.carouselWidth <
        // this.carouselWidth
        this.slide + 1 == this.numberOfSlides
      ) {
        this.next.classList.add("disabled");
      } else {
        this.next.classList.remove("disabled");
      }
    } else {
      this.setMobileArrowDisabled();
    }
  };

  setPrev = () => {
    if (this.slide > 0) {
      this.slide--;
    }
    this.setSlide();
    this.next.classList.remove("disabled");

    if (this.slide === 0) {
      this.prev.classList.add("disabled");
    } else {
      this.prev.classList.remove("disabled");
    }
  };
}
